import { configureStore } from "@reduxjs/toolkit";

import theme from "../../../../hooks/use-theme";
import causal from "./causal";
import query from "./query";
import graph from "./graph";
import user from "./user";

const store = configureStore({
  reducer: { theme, query, causal, graph, user },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type AppDispatch = typeof store.dispatch;
export default store;
